import { render } from "./Customer.vue?vue&type=template&id=76849941&scoped=true"
import script from "./Customer.vue?vue&type=script&lang=js"
export * from "./Customer.vue?vue&type=script&lang=js"

import "./Customer.vue?vue&type=style&index=0&id=76849941&lang=css"
import "./Customer.vue?vue&type=style&index=1&id=76849941&lang=css"
import "./Customer.vue?vue&type=style&index=2&id=76849941&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76849941"]])

export default __exports__